import { useMutation } from 'query';
import { useAdminDashboardRedirect } from '../../hooks';

type Variables = {
  referrer: string;
};

export const useAdminDashboardRedirectMutation = () => {
  const adminDashboardRedirect = useAdminDashboardRedirect();

  return useMutation<undefined, Variables>({
    async mutationFn({ referrer }: Variables) {
      await adminDashboardRedirect(referrer);
      return undefined;
    },
  });
};
